import { render } from "./introduce.vue?vue&type=template&id=7d1a69ad"
import script from "./introduce.vue?vue&type=script&lang=js"
export * from "./introduce.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Project\\2022\\management-system\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__